document.querySelectorAll('button.hotspot').forEach((hotspot) => {
    const hotspotDrawer = document.querySelector(`#${hotspot.dataset.hotspotId}`);
    
    hotspot.addEventListener('click', () => {
        hotspotDrawer.classList.add('hotspot__drawer--active');
    });

    const closeBtn = hotspotDrawer.querySelector('.hotspot__drawer-close');
    closeBtn.addEventListener('click', () => {
        hotspotDrawer.classList.remove('hotspot__drawer--active');
    });
    
    // Close drawer when clicked outside but in the drawer
    hotspotDrawer.addEventListener('click', (e) => {
        e.stopPropagation();
        if(e.target === hotspotDrawer) {
            hotspotDrawer.classList.remove('hotspot__drawer--active');
        }
    });

})

